import Controller from '@ember/controller';

export default class AuthenticatedTeamsShowProjectsShowProjectVersionsIndexController extends Controller {}
